import { TextInput } from '@mantine/core'

export default {
  TextInput: TextInput.extend({
    styles: (_theme, params) => ({
      input: {
        borderRadius: '8px',
        cursor: params.readOnly ? 'not-allowed' : undefined,
        color: params.readOnly ? 'var(--gray-40-color)' : undefined,
      },
    }),
  }),
}
